import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type LazyListItemProps = ComponentProps<typeof LazyListItem>;

export const LazyListItem = styled("li", {});

LazyListItem.displayName = "LazyListItem";
